import { Injectable, signal } from '@angular/core';
import { MenuItem } from 'primeng/api';

@Injectable({
  providedIn: 'root'
})
export class CustomBreadcrumbService {

  items = signal<MenuItem[] | undefined>(undefined);

  public setItems(newItems: MenuItem[]){
    this.items.set(newItems);
  }

  public addItem(newItem: MenuItem){
    var newArr = [...this.items()!,newItem];
    this.items.set(newArr);
  }
    
}


